import React from 'react';
import cn from 'classnames';
import { DefaultProps } from 'types/interfaces/DefaultProps';

import { Box } from '@lyearn/ui';

export interface LabelProps extends DefaultProps {
  label?: string;
}

const Tag: React.FC<LabelProps> = (props) => {
  const { label, className } = props;
  return <Box className={cn('xs:text-xs text-background uppercase', className)}>{label}</Box>;
};

export default Tag;
